import { Button } from "@itandi/itandi-bb-ui/Button";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { Input } from "@itandi/itandi-bb-ui/Input";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import type { AdminCompanyStoreSettingEdit } from "~/models/CompanyStoreSetting";
import { update } from "~/utils/api/admin/CompanyStoreSetting";
import { isSuccess } from "~/utils/api/api_handler";
import Styles from "./CompanyStoreSettingForm.module.scss";

type Props = {
	companyStoreSetting: AdminCompanyStoreSettingEdit;
};

export const CompanyStoreSettingForm: React.FC<Props> = ({
	companyStoreSetting
}) => {
	const { notify } = useNotification();
	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const { register, getValues, handleSubmit } =
		useForm<AdminCompanyStoreSettingEdit>({
			defaultValues: {
				robotPaymentStoreCode: companyStoreSetting.robotPaymentStoreCode
			},
			mode: "onBlur"
		});
	const onClickSubmit = useCallback(() => {
		handleSubmit(() => {
			setIsConfirmModalOpen(true);
		})();
	}, [handleSubmit]);
	const handleAccept = useCallback(async () => {
		const values = getValues();
		const response = await update(values);
		if (isSuccess(response)) {
			notify({ content: "保存しました。", variant: "success" });
			setIsConfirmModalOpen(false);
			return;
		}
		notify({ content: "保存に失敗しました。", variant: "error" });
	}, [getValues, notify]);
	return (
		<div className={Styles.FormContainer}>
			<FormControl label="請求管理ロボ用店舗コード" variant="vertical">
				<Input {...register("robotPaymentStoreCode")} />
			</FormControl>
			<div>
				<Button onClick={onClickSubmit} variant="primary">
					保存
				</Button>
			</div>
			<Modalv2
				isOpen={isConfirmModalOpen}
				onClose={() => {
					setIsConfirmModalOpen(false);
				}}
				size="s"
			>
				<ModalHeader title="設定の保存" />
				<ModalBody>設定を保存します。</ModalBody>
				<ModalFooter
					leftArea={
						<Button
							onClick={() => {
								setIsConfirmModalOpen(false);
							}}
							variant="secondary"
						>
							キャンセル
						</Button>
					}
					rightArea={
						<Button onClick={handleAccept} variant="primary">
							保存
						</Button>
					}
				/>
			</Modalv2>
		</div>
	);
};
